import { useState } from 'react';
import { Input, Modal, Flex, FlexItem } from '@bigcommerce/big-design';
import './PriceEditPopup.css';

export default function PriceEditPopup({
	isOpen,
	setIsOpen,
	updateOrderProduct,
	price,
}) {
	const [customPrice, setCustomPrice] = useState('');
	const [percentageChange, setPercentageChange] = useState('');

	const updatePrice = () => {
		if (percentageChange && percentageChange.length > 0)
			setCustomPrice(price - price * 0.01 * percentageChange);

		updateOrderProduct('amount_off', percentageChange);
		updateOrderProduct('new_price', customPrice);
		setIsOpen(false);
	};

	// I have to pass the value into the function because otherwise it runs before the state value is finished updating
	const calculateCustomPrice = (newValue) => {
		if (newValue > 100) {
			setPercentageChange(100);
			setCustomPrice(0);
		} else if (newValue?.length > 0) {
			setCustomPrice(
				parseFloat(price) -
					(parseFloat(newValue) / 100) * parseFloat(price),
			);
		}
	};

	// I have to pass the value into the function because otherwise it runs before the state value is finished updating
	const calculatePercentage = (newPrice) => {
		if (newPrice?.length > 0) {
			const diff = parseFloat(price) - parseFloat(newPrice);
			const percentage = (diff / parseFloat(price)) * 100;
			setPercentageChange(Math.ceil(percentage));
		}
	};

	const handleKeyUp = (e) => {
		if (e.key === 'Enter') updatePrice();
	};

	return (
		<Modal
			actions={[
				{
					text: 'Cancel',
					variant: 'subtle',
					onClick: () => setIsOpen(false),
				},
				{
					text: 'Done',
					onClick: () => {
						updatePrice();
					},
				},
			]}
			header="Custom Price"
			isOpen={isOpen}
			onClose={() => setIsOpen(false)}
			closeOnEscKey={true}
			closeOnClickOutside={true}
		>
			<Flex padding="medium" flexWrap="wrap">
				<FlexItem
					flexBasis="100%"
					flexGrow={0}
					flexOrder={0}
					paddingRight="xLarge"
				>
					<Input
						label="New Price"
						type="number"
						required
						value={customPrice}
						onChange={(e) => {
							setCustomPrice(e.target.value);
							calculatePercentage(e.target.value);
						}}
						onKeyUp={handleKeyUp}
					/>
				</FlexItem>
				<FlexItem
					flexBasis="100%"
					flexGrow={0}
					flexOrder={0}
					paddingRight="xLarge"
				>
					<Input
						label="Percentage Discount"
						type="number"
						required
						value={percentageChange}
						onChange={(e) => {
							setPercentageChange(e.target.value);
							calculateCustomPrice(e.target.value);
						}}
						onKeyUp={handleKeyUp}
					/>
				</FlexItem>
			</Flex>
		</Modal>
	);
}
